import { useTimer } from 'src/contexts';

import PageTitleTemplate from './PageTitleTemplate';

const PLAY_SYMBOL = '▶';

/**
 * Puts a play symbol ahead of the page title while a timer is running, so the
 * tab says so even when the page itself is out of sight.
 */
export default function TimerPageTitle() {
  const { running } = useTimer();
  if (!running) return null;

  return <PageTitleTemplate prefix={`${PLAY_SYMBOL} `} />;
}
